/**
=========================================================
* E4A-IoT-Manager React Frontend Dashboard 
* Copyright © 2024 Electronics4All Inc.
=========================================================
*/
// React hooks and part code management service
import { useState, useEffect } from "react";
import organizationsService from "services/organizations.service";

// MUI and Material Dashboard Components
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import MDBox from "components/MDBox";

import List from "@mui/material/List";
import ListSubheader from "@mui/material/ListSubheader";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";


export default function FiltersDialog({
    handleClose,
    open,
    submit
}) {
    const [openCollapse, setOpenCollapse] = useState(false);
    const [organizations, setOrganizations] = useState([]);
    const [selectedOrganizations, setSelectedOrganizations] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                const orgsResponse = await organizationsService.getOrganizations();
                const mapped = orgsResponse.map((m) => ({
                    id: m._id,
                    name: m.name,
                }));
                setOrganizations(mapped);
                const mapSelected = mapped.map((m) => m.id);
                setSelectedOrganizations(mapSelected);
            } catch (error) {
                console.error("Error fetching organizations: ", error);
            }
        })();
    }, []);

    // Handles Locations Category Collapse
    const handleClick = () => {
        setOpenCollapse(!openCollapse);
    };

    // Handles Organizations checkboxes
    const handleToggle = (value) => () => {
        const currentIndex = selectedOrganizations.indexOf(value);
        const newSelectedOrganizations = [...selectedOrganizations];

        if (currentIndex === -1) {
            newSelectedOrganizations.push(value);
        } else {
            newSelectedOrganizations.splice(currentIndex, 1);
        }

        setSelectedOrganizations(newSelectedOrganizations);
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
        >
            <DialogTitle>Add Filters</DialogTitle>
            <DialogContent>
                <MDBox >

                    {isLoading ? (
                        <MDBox
                            display="flex"
                            justifyContent="center"
                        >
                            <CircularProgress />
                        </MDBox>
                    ):(
                    <List
                        sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                        subheader={
                            <ListSubheader component="div" id="nested-list-subheader">
                                Product Filters
                            </ListSubheader>
                        }
                    >   {/* Locations */}
                        <ListItemButton onClick={handleClick} sx={{ pl: 4 }}>
                            <ListItemIcon>
                                <CorporateFareIcon />
                            </ListItemIcon>
                            <ListItemText primary="Organizations" />
                            {openCollapse ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>

                        <Collapse in={openCollapse} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>

                                {organizations.map((org) => (
                                    <ListItemButton
                                        key={org.id}
                                        sx={{ pl: 4 }}
                                        onClick={handleToggle(org.id)}
                                    >
                                        <ListItemIcon>
                                            <Checkbox
                                                edge="start"
                                                disableRipple
                                                size="small"
                                                checked={selectedOrganizations.includes(org.id)}
                                            />
                                        </ListItemIcon>
                                        <ListItemText primary={org.name} size="small"/>
                                    </ListItemButton>
                                ))}
                            </List>
                        </Collapse>

                    </List>)}
                </MDBox>
            </DialogContent>
            <DialogActions>

                <Button onClick={handleClose}> Cancel </Button>
                <Button onClick={() => submit(selectedOrganizations)}> Apply Filters </Button>

            </DialogActions>
        </Dialog>
    )
}